export interface HowItWorksStep {
  id: string;
  number: number;
  icon: string;
  titleKey: string;
  descKey: string;
  noteKey: string;
  itemKeys: string[];
  image: string;
}

export const howItWorksHeroImage =
  'https://readdy.ai/api/search-image?query=A%20wide%20panoramic%20view%20of%20a%20modern%20cosmetic%20packaging%20factory%20production%20floor%20at%20work%2C%20automated%20filling%20and%20assembly%20lines%20stretching%20into%20the%20distance%2C%20glass%20bottles%20and%20plastic%20containers%20moving%20along%20illuminated%20conveyor%20belts%2C%20clean%20bright%20industrial%20environment%20with%20soft%20daylight%2C%20professional%20editorial%20industrial%20photography%2C%20crisp%20detail%20and%20balanced%20composition&width=1800&height=1000&seq=hiw-hero-01&orientation=landscape';

export const howItWorksSteps: HowItWorksStep[] = [
  {
    id: 'search-inquiry',
    number: 1,
    icon: 'ri-search-eye-line',
    titleKey: 'steps.1.title',
    descKey: 'steps.1.desc',
    noteKey: 'steps.1.note',
    image:
      'https://readdy.ai/api/search-image?query=A%20person%20browsing%20a%20large%20screen%20displaying%20a%20clean%20grid%20of%20cosmetic%20packaging%20product%20cards%2C%20glass%20bottles%20cream%20jars%20and%20pump%20bottles%20arranged%20in%20a%20modern%20online%20catalog%20interface%2C%20bright%20minimalist%20office%20environment%20with%20warm%20neutral%20tones%2C%20professional%20product%20photography%2C%20high%20detail&width=1200&height=800&seq=hiw-step-01&orientation=landscape',
    itemKeys: [
      'steps.1.item1',
      'steps.1.item2',
      'steps.1.item3',
      'steps.1.item4',
      'steps.1.item5',
    ],
  },
  {
    id: 'requirements-review',
    number: 2,
    icon: 'ri-file-list-3-line',
    titleKey: 'steps.2.title',
    descKey: 'steps.2.desc',
    noteKey: 'steps.2.note',
    image:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20technical%20specification%20sheet%20and%20engineering%20drawings%20for%20a%20cosmetic%20container%20reviewed%20on%20a%20desk%2C%20printed%20blueprints%20with%20dimension%20annotations%20next%20to%20material%20and%20color%20swatch%20samples%2C%20a%20designer%20pointing%20at%20details%2C%20clean%20professional%20studio%20lighting%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1200&height=800&seq=hiw-step-02&orientation=landscape',
    itemKeys: [
      'steps.2.item1',
      'steps.2.item2',
      'steps.2.item3',
      'steps.2.item4',
      'steps.2.item5',
      'steps.2.item6',
      'steps.2.item7',
      'steps.2.item8',
    ],
  },
  {
    id: 'quotation-confirmation',
    number: 3,
    icon: 'ri-calculator-line',
    titleKey: 'steps.3.title',
    descKey: 'steps.3.desc',
    noteKey: 'steps.3.note',
    image:
      'https://readdy.ai/api/search-image?query=A%20clean%20business%20desk%20with%20a%20printed%20quotation%20document%20showing%20itemized%20pricing%20tables%2C%20a%20calculator%20and%20a%20pen%2C%20coffee%20cup%20nearby%2C%20soft%20natural%20window%20light%2C%20warm%20minimalist%20office%20setting%2C%20professional%20editorial%20photography%2C%20high%20detail%20and%20crisp%20focus&width=1200&height=800&seq=hiw-step-03&orientation=landscape',
    itemKeys: [
      'steps.3.item1',
      'steps.3.item2',
      'steps.3.item3',
      'steps.3.item4',
      'steps.3.item5',
      'steps.3.item6',
      'steps.3.item7',
      'steps.3.item8',
    ],
  },
  {
    id: 'sample-approval',
    number: 4,
    icon: 'ri-flask-line',
    titleKey: 'steps.4.title',
    descKey: 'steps.4.desc',
    noteKey: 'steps.4.note',
    image:
      'https://readdy.ai/api/search-image?query=Several%20physical%20prototype%20samples%20of%20cosmetic%20packaging%20including%20glass%20bottles%20and%20pump%20bottles%20arranged%20on%20a%20clean%20white%20table%20being%20inspected%20by%20hand%2C%20various%20finishes%20and%20color%20swatches%20nearby%2C%20bright%20soft%20studio%20lighting%2C%20minimal%20clean%20background%2C%20professional%20product%20photography%2C%20high%20detail&width=1200&height=800&seq=hiw-step-04&orientation=landscape',
    itemKeys: [
      'steps.4.item1',
      'steps.4.item2',
      'steps.4.item3',
      'steps.4.item4',
      'steps.4.item5',
      'steps.4.item6',
      'steps.4.item7',
    ],
  },
  {
    id: 'order-payment',
    number: 5,
    icon: 'ri-hand-coin-line',
    titleKey: 'steps.5.title',
    descKey: 'steps.5.desc',
    noteKey: 'steps.5.note',
    image:
      'https://readdy.ai/api/search-image?query=A%20professional%20signing%20of%20a%20business%20contract%20with%20a%20pen%20on%20formal%20documents%2C%20a%20proforma%20invoice%20and%20order%20confirmation%20papers%20on%20a%20clean%20desk%2C%20hands%20visible%20signing%20the%20agreement%2C%20warm%20professional%20office%20lighting%2C%20editorial%20business%20photography%2C%20high%20detail&width=1200&height=800&seq=hiw-step-05&orientation=landscape',
    itemKeys: [
      'steps.5.item1',
      'steps.5.item2',
      'steps.5.item3',
      'steps.5.item4',
      'steps.5.item5',
      'steps.5.item6',
      'steps.5.item7',
    ],
  },
  {
    id: 'pre-production',
    number: 6,
    icon: 'ri-settings-4-line',
    titleKey: 'steps.6.title',
    descKey: 'steps.6.desc',
    noteKey: 'steps.6.note',
    image:
      'https://readdy.ai/api/search-image?query=Engineers%20inspecting%20a%20precision%20injection%20mold%20and%20production%20equipment%20inside%20a%20clean%20factory%20workshop%2C%20a%20technician%20checking%20machine%20settings%20on%20a%20control%20panel%2C%20bright%20industrial%20lighting%2C%20organized%20tooling%20area%2C%20professional%20industrial%20photography%2C%20high%20detail&width=1200&height=800&seq=hiw-step-06&orientation=landscape',
    itemKeys: [
      'steps.6.item1',
      'steps.6.item2',
      'steps.6.item3',
      'steps.6.item4',
      'steps.6.item5',
      'steps.6.item6',
    ],
  },
  {
    id: 'raw-material-qc',
    number: 7,
    icon: 'ri-checkbox-circle-line',
    titleKey: 'steps.7.title',
    descKey: 'steps.7.desc',
    noteKey: 'steps.7.note',
    image:
      'https://readdy.ai/api/search-image?query=A%20quality%20inspector%20in%20a%20white%20coat%20examining%20incoming%20raw%20material%20samples%20of%20plastic%20resin%20and%20glass%20cullet%20in%20a%20clean%20laboratory%2C%20measuring%20tools%20and%20color%20reference%20cards%20on%20the%20bench%2C%20bright%20sterile%20lab%20lighting%2C%20professional%20industrial%20photography%2C%20high%20detail&width=1200&height=800&seq=hiw-step-07&orientation=landscape',
    itemKeys: [
      'steps.7.item1',
      'steps.7.item2',
      'steps.7.item3',
      'steps.7.item4',
      'steps.7.item5',
      'steps.7.item6',
    ],
  },
  {
    id: 'mass-production',
    number: 8,
    icon: 'ri-cpu-line',
    titleKey: 'steps.8.title',
    descKey: 'steps.8.desc',
    noteKey: 'steps.8.note',
    image:
      'https://readdy.ai/api/search-image?query=A%20wide%20view%20of%20a%20fully%20automated%20cosmetic%20packaging%20production%20line%20with%20robotic%20arms%20and%20conveyor%20belts%20moving%20glass%20bottles%20and%20plastic%20containers%20at%20high%20speed%2C%20rows%20of%20modern%20injection%20molding%20and%20blow%20molding%20machines%2C%20clean%20bright%20industrial%20factory%20floor%2C%20professional%20industrial%20photography%2C%20crisp%20detail&width=1600&height=900&seq=hiw-step-08&orientation=landscape',
    itemKeys: [
      'steps.8.item1',
      'steps.8.item2',
      'steps.8.item3',
      'steps.8.item4',
      'steps.8.item5',
      'steps.8.item6',
    ],
  },
  {
    id: 'in-process-qc',
    number: 9,
    icon: 'ri-scan-line',
    titleKey: 'steps.9.title',
    descKey: 'steps.9.desc',
    noteKey: 'steps.9.note',
    image:
      'https://readdy.ai/api/search-image?query=A%20quality%20control%20worker%20inspecting%20cosmetic%20bottles%20directly%20on%20the%20production%20line%2C%20checking%20dimensions%20and%20appearance%20under%20a%20bright%20inspection%20lamp%2C%20bottles%20moving%20on%20a%20conveyor%20belt%20beside%20them%2C%20clean%20industrial%20environment%2C%20professional%20industrial%20photography%2C%20high%20detail&width=1200&height=800&seq=hiw-step-09&orientation=landscape',
    itemKeys: [
      'steps.9.item1',
      'steps.9.item2',
      'steps.9.item3',
      'steps.9.item4',
      'steps.9.item5',
      'steps.9.item6',
      'steps.9.item7',
      'steps.9.item8',
    ],
  },
  {
    id: 'final-inspection',
    number: 10,
    icon: 'ri-shield-check-line',
    titleKey: 'steps.10.title',
    descKey: 'steps.10.desc',
    noteKey: 'steps.10.note',
    image:
      'https://readdy.ai/api/search-image?query=A%20bright%20quality%20control%20laboratory%20where%20finished%20cosmetic%20bottles%20are%20inspected%20under%20a%20light%20box%20for%20defects%2C%20a%20technician%20comparing%20a%20finished%20product%20against%20an%20approved%20sample%2C%20precise%20measuring%20instruments%20on%20the%20bench%2C%20clean%20sterile%20lab%20environment%2C%20professional%20industrial%20photography%2C%20high%20detail&width=1200&height=800&seq=hiw-step-10&orientation=landscape',
    itemKeys: [
      'steps.10.item1',
      'steps.10.item2',
      'steps.10.item3',
      'steps.10.item4',
      'steps.10.item5',
      'steps.10.item6',
      'steps.10.item7',
      'steps.10.item8',
      'steps.10.item9',
      'steps.10.item10',
    ],
  },
  {
    id: 'packaging-shipment',
    number: 11,
    icon: 'ri-inbox-archive-line',
    titleKey: 'steps.11.title',
    descKey: 'steps.11.desc',
    noteKey: 'steps.11.note',
    image:
      'https://readdy.ai/api/search-image?query=Workers%20carefully%20packing%20cosmetic%20bottles%20into%20protective%20inserts%20and%20export%20cartons%20on%20a%20packaging%20line%2C%20labeled%20boxes%20being%20sealed%20and%20stacked%20on%20pallets%2C%20clean%20organized%20warehouse%20area%2C%20bright%20industrial%20lighting%2C%20professional%20industrial%20photography%2C%20high%20detail&width=1200&height=800&seq=hiw-step-11&orientation=landscape',
    itemKeys: [
      'steps.11.item1',
      'steps.11.item2',
      'steps.11.item3',
      'steps.11.item4',
      'steps.11.item5',
      'steps.11.item6',
      'steps.11.item7',
      'steps.11.item8',
    ],
  },
  {
    id: 'shipping-tracking',
    number: 12,
    icon: 'ri-ship-line',
    titleKey: 'steps.12.title',
    descKey: 'steps.12.desc',
    noteKey: 'steps.12.note',
    image:
      'https://readdy.ai/api/search-image?query=Shipping%20containers%20being%20loaded%20onto%20a%20cargo%20ship%20at%20a%20busy%20international%20port%2C%20gantry%20cranes%20moving%20containers%2C%20stacks%20of%20colorful%20export%20containers%2C%20bright%20daylight%20with%20clear%20sky%2C%20professional%20logistics%20and%20industrial%20photography%2C%20high%20detail&width=1200&height=800&seq=hiw-step-12&orientation=landscape',
    itemKeys: [
      'steps.12.item1',
      'steps.12.item2',
      'steps.12.item3',
      'steps.12.item4',
      'steps.12.item5',
      'steps.12.item6',
      'steps.12.item7',
    ],
  },
  {
    id: 'after-sales',
    number: 13,
    icon: 'ri-customer-service-2-line',
    titleKey: 'steps.13.title',
    descKey: 'steps.13.desc',
    noteKey: 'steps.13.note',
    image:
      'https://readdy.ai/api/search-image?query=A%20customer%20receiving%20and%20inspecting%20a%20delivered%20box%20of%20cosmetic%20packaging%20at%20their%20workspace%2C%20opening%20a%20neatly%20packed%20carton%20of%20bottles%2C%20a%20friendly%20customer%20support%20professional%20assisting%2C%20bright%20warm%20office%20environment%2C%20professional%20business%20photography%2C%20high%20detail&width=1200&height=800&seq=hiw-step-13&orientation=landscape',
    itemKeys: [
      'steps.13.item1',
      'steps.13.item2',
      'steps.13.item3',
      'steps.13.item4',
      'steps.13.item5',
      'steps.13.item6',
      'steps.13.item7',
    ],
  },
];

export const orderStatusKeys = [
  'progress.status1',
  'progress.status2',
  'progress.status3',
  'progress.status4',
  'progress.status5',
  'progress.status6',
  'progress.status7',
  'progress.status8',
  'progress.status9',
  'progress.status10',
  'progress.status11',
];

export interface QaStage {
  icon: string;
  titleKey: string;
  descKey: string;
}

export const qaStages: QaStage[] = [
  { icon: 'ri-truck-line', titleKey: 'qa.stage1.title', descKey: 'qa.stage1.desc' },
  { icon: 'ri-settings-4-line', titleKey: 'qa.stage2.title', descKey: 'qa.stage2.desc' },
  { icon: 'ri-scan-line', titleKey: 'qa.stage3.title', descKey: 'qa.stage3.desc' },
  { icon: 'ri-shield-check-line', titleKey: 'qa.stage4.title', descKey: 'qa.stage4.desc' },
  { icon: 'ri-inbox-archive-line', titleKey: 'qa.stage5.title', descKey: 'qa.stage5.desc' },
  { icon: 'ri-ship-line', titleKey: 'qa.stage6.title', descKey: 'qa.stage6.desc' },
];